module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado11.d6b9c1ab.svg";